import { action } from 'typesafe-actions';
import { DetalheVeiculoTypes, IDetalheVeiculo } from './types';

export const loadRequest = (codVeiculo?: number) =>
  action(DetalheVeiculoTypes.LOAD_REQUEST, { codVeiculo });
export const loadSuccess = (data: IDetalheVeiculo[]) =>
  action(DetalheVeiculoTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(DetalheVeiculoTypes.LOAD_FAILURE, {});
